import * as ContractServices from "../../helpers/services/ContractServices";
import * as CompanyServices from "../../helpers/services/CompanyServices";
import { receiveErrors } from "../error/error.actions";
import ContractActionTypes from "./contract.types";

const setIsFetching = () => ({
  type: ContractActionTypes.RETRIEVE_CONTRACTS,
  payload: { isFetching: true },
});

const setIsDetailsFetching = () => ({
  type: ContractActionTypes.RETRIEVE_CONTRACTS,
  payload: { isDetailsFetching: true },
});
const _retrieveContracts = (companies) => ({
  type: ContractActionTypes.RETRIEVE_CONTRACTS,
  payload: { contractsList: companies, isFetching: false },
});

export const retrieveContracts = () => async (dispatch) => {
  dispatch(setIsFetching());

  try {
    const response = await ContractServices.getContracts();
    return dispatch(_retrieveContracts(response));
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const retrieveContract = (contractId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());

  try {
    const response = await ContractServices.getContract({ contractId });
    console.log("*****************8");
    console.log(response);
    dispatch(selectContract(response));
  } catch (error) {
    return dispatch(receiveErrors(error));
  }
};

export const retrieveCompanySubsidiaries = (companyId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());
  try {
    const response = await CompanyServices.getCompanySubsidiaries(companyId);
    return dispatch({
      type: ContractActionTypes.RETRIEVE_CONTRACT_DETAILS,
      payload: { subsidiaries: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const retrieveCompanyAddresses = (companyId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());
  try {
    const response = await CompanyServices.getCompanyAddresses(companyId);
    return dispatch({
      type: ContractActionTypes.RETRIEVE_CONTRACT_DETAILS,
      payload: { addresses: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const retrieveContractAppendices = (contractId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());

  try {
    const response = await ContractServices.getContractAppendices(contractId);
    return dispatch({
      type: ContractActionTypes.RETRIEVE_CONTRACT_DETAILS,
      payload: { appendices: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const selectContract = (contract) => ({
  type: ContractActionTypes.RETRIEVE_CONTRACTS,
  payload: { selectedContract: contract },
});
